module.exports = __webpack_public_path__ + "img/cover.1d9d6e29.jpg";